import OadpButton from './oadp-button';
export default OadpButton;
